import React from "react";

import { useDeviceContext } from "../../../context/DeviceContext";
import { updateColourScheme } from "../../../utils/nativeUtils/customActions";
import { FeatureSentiment } from "../../Shared/FeatureSentiment";
import EDSThemeToggle from "../../Shared/ThemeToggle/EDSThemeToggle";
import FullScreen from "./FullScreen";

export type HeaderContainerProps = {
  start?: React.JSX.Element | string;
  middle?: React.JSX.Element | string;
  end?: React.JSX.Element | string;
  featureSentimentName?: string;
};

const headerItemBaseClasses =
  "HeaderContainer__headerItem flex self-center flex-1 px-panel-padding content-center h-full items-center";

export const HeaderContainer = ({
  start,
  middle,
  end,
  featureSentimentName
}: HeaderContainerProps) => {
  const { colourScheme, setTheme } = useDeviceContext();

  const handleThemeToggle = async (isDarkMode: boolean) => {
    const themeName = isDarkMode ? "Dark" : "Light";
    setTheme(themeName);
    await updateColourScheme(themeName);
  };

  return (
    <div className="HeaderContainer flex-[1_0_auto] self-stretch flex flex-row flex-nowrap justify-center content-start items-center bg-page-background text-heading-color pt-3">
      <div className={`${headerItemBaseClasses} justify-start`}>
        {start || ""}
      </div>
      <div className={`${headerItemBaseClasses} justify-center`}>
        {middle || ""}
      </div>
      <div
        className={`${headerItemBaseClasses} justify-end overflow-hidden min-w-fit`}
      >
        {featureSentimentName && (
          <FeatureSentiment feature={featureSentimentName} />
        )}
        {end || ""}
        <EDSThemeToggle
          isDarkMode={colourScheme === "dark"}
          onToggle={handleThemeToggle}
        />
        <div className="ml-2">
          <FullScreen />
        </div>
      </div>
    </div>
  );
};
